import { render } from "./EditRequest6.vue?vue&type=template&id=54c3a89e"
import script from "./EditRequest6.vue?vue&type=script&lang=js"
export * from "./EditRequest6.vue?vue&type=script&lang=js"

import "./EditRequest6.vue?vue&type=style&index=0&id=54c3a89e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__